export function signInUrl(backPath?: string): string {
    if (!backPath || backPath === '/' || backPath.startsWith('/auth/')) {
        return '/auth/sign-in'
    }
    return `/auth/sign-in?back=${encodeURIComponent(backPath)}`
}
